import { BaseStore } from "../BaseStore";
import { INavigationStoreState } from "./INavigationStoreState";
import { Dispatcher } from "../Dispatcher";
import { INavigationAction } from "./INavigationAction";
import { RouteFragment } from "../../Routing/RouteFragment";
import { NavigationActionType } from "./NavigationActionType";
import * as $ from "jquery";

export class NavigationStoreStatic extends BaseStore<INavigationStoreState> {
    private _navigationDispatcher: Dispatcher<INavigationAction>;
    constructor(navigationDispatcher: Dispatcher<INavigationAction>) {
        super();
        this.debugEnabled = false;
        this._navigationDispatcher = navigationDispatcher;
        this.initializeBindings();
    }

    public getActiveUrl(): RouteFragment {
        return $.extend({}, this.getState().activeUrl);
    }

    public isLoading(): boolean {
        return false;
    }

    protected statesEqual(currentState: INavigationStoreState, newState: INavigationStoreState): boolean {
        if (currentState.activeUrl == null && newState.activeUrl == null) {
            return true;
        }

        if (currentState.activeUrl == null || newState.activeUrl == null) {
            return false;
        }

        if (currentState.activeUrl !== newState.activeUrl) {
            return false;
        }

        return true;
    }

    protected getDefaultState(): INavigationStoreState {
        const defaultState: INavigationStoreState = { activeUrl: null };
        return defaultState;
    }

    private initializeBindings(): void {
        this.subscribeToDispatcher(this._navigationDispatcher, (eventData: INavigationAction) =>
            this.onNavigationDispatch(eventData)
        );
    }

    private onNavigationDispatch(navigationAction: INavigationAction): void {
        switch (navigationAction.actionType) {
            case NavigationActionType.Enter:
                this.appendUrl(navigationAction.url);
                break;
            default:
                throw new Error(
                    "NavigationStoreStatic.onNavigationDispatch: Unexpected navigation action type " +
                        navigationAction.actionType
                );
        }
    }

    private appendUrl(urlFragment: RouteFragment): void {
        const newState: INavigationStoreState = { activeUrl: urlFragment };
        this.setState(newState);
    }
}
